<template>
  <div style="display:flex;justify-content: center;min-height: 50vh;width: 100%;align-items: center;color:red;">
    <h3>{{ $t('message.access_restricted') }}</h3>
  </div>
</template>
